import { PLANS, BLOCKS, CATALOG } from "./growthPoints";
import standaloneOffers from "./standaloneOffers.json";

export const STANDALONE_OFFERS = standaloneOffers.map((p) => ({ ...p, standalone: true }));

export const catalogProductId = (group, item) => `service:${group.id}:${item.name}`;
export const applicationHref = (id) => `/apply?product=${encodeURIComponent(id)}`;
export const APPLICATION_PRODUCTS = [
  ...STANDALONE_OFFERS,
  ...PLANS.map((p) => ({ id: p.id, name: p.name })),
  ...BLOCKS.map((p) => ({ id: p.id, name: p.name })),
  ...CATALOG.flatMap((g) => g.items.map((item) => ({ id: catalogProductId(g, item), name: `${item.name} — ${g.name}` }))),
];
export const applicationProduct = (id) => APPLICATION_PRODUCTS.find((p) => p.id === id);
